// extracted by mini-css-extract-plugin
module.exports = {"Table":"Drilldowns_Table__3FQvp"};